// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lthK","placeholdersHeader":"styles_placeholdersHeader__2u1f-","editorStyle":"styles_editorStyle__30J4Z","placeholdersBox":"styles_placeholdersBox__3cDbe"};